// Announcement bar marquee
// Historia de este ajuste, para no repetir el error:
//  - Originalmente avanzaba 0.4px por frame: lento y ademas dependiente de los FPS
//    (en una pantalla de 120Hz iba al doble de rapido).
//  - Se paso a 90 px/s por tiempo real, pero ese valor se afino mirando escritorio.
//    Cada mensaje ocupa el ancho de la pantalla, asi que a 90 px/s tarda ~17s en cruzar
//    en un monitor de 1500px pero solo ~4s en un movil de 390px: ilegible en movil.
//  - Ahora la velocidad es proporcional al ancho de pantalla, de forma que cada mensaje
//    tarda mas o menos lo mismo en cruzar (~9s) en cualquier dispositivo.
// SEGUNDOS_POR_MENSAJE es la palanca: subelo para que vaya mas lento, bajalo para mas ritmo.
(function(){
  var t=document.getElementById('annTrack');if(!t)return;
  var SEGUNDOS_POR_MENSAJE=9;
  var MIN_PX_SEG=40, MAX_PX_SEG=95;

  var items=Array.from(t.children);
  items.forEach(function(i){var c=i.cloneNode(true);c.setAttribute('aria-hidden','true');t.appendChild(c);});

  var pxSeg=MIN_PX_SEG;
  function calcular(){
    // cada .announcement-item mide el ancho del viewport (min-width:100%)
    var ancho=window.innerWidth||t.offsetWidth||390;
    var v=ancho/SEGUNDOS_POR_MENSAJE;
    pxSeg=Math.max(MIN_PX_SEG,Math.min(MAX_PX_SEG,v));
  }
  calcular();
  window.addEventListener('resize',calcular);
  window.addEventListener('orientationchange',calcular);

  var pos=0,last=null;
  function tick(ts){
    if(last===null)last=ts;
    var dt=(ts-last)/1000;
    last=ts;
    if(dt>0.25)dt=0.25; // evita un salto al volver de una pestana en segundo plano
    pos-=pxSeg*dt;
    if(Math.abs(pos)>=t.scrollWidth/2)pos=0;
    t.style.transform='translateX('+pos+'px)';
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
})();

// Hero carousel
// SLIDE_MS = milisegundos que se muestra cada banner antes de pasar al siguiente.
(function(){
  var track=document.getElementById('carousel');
  var dotsWrap=document.getElementById('dots');
  if(!track)return;
  var SLIDE_MS=4000;
  var slides=track.querySelectorAll('.slide');
  var total=slides.length;
  var current=0;
  var dots=[];
  for(var i=0;i<total;i++){
    var d=document.createElement('button');
    d.className='dot'+(i===0?' active':'');
    d.setAttribute('aria-label','Slide '+(i+1));
    (function(idx){d.addEventListener('click',function(){goTo(idx);});})(i);
    dotsWrap.appendChild(d);
    dots.push(d);
  }
  function goTo(n){
    current=n;
    track.style.transform='translateX(-'+current*100+'%)';
    dots.forEach(function(d,i){d.className='dot'+(i===current?' active':'');});
  }
  var prev=document.querySelector('.carousel-prev');
  var next=document.querySelector('.carousel-next');
  if(prev)prev.addEventListener('click',function(){goTo((current-1+total)%total);});
  if(next)next.addEventListener('click',function(){goTo((current+1)%total);});
  var timer=setInterval(function(){goTo((current+1)%total);},SLIDE_MS);
  track.closest('.hero').addEventListener('mouseenter',function(){clearInterval(timer);});
  track.closest('.hero').addEventListener('mouseleave',function(){timer=setInterval(function(){goTo((current+1)%total);},SLIDE_MS);});
})();

// Reviews marquee — duplicate cards + start infinite scroll animation
(function(){
  var track=document.getElementById('rmarqueeTrack');
  if(!track)return;
  var orig=Array.from(track.querySelectorAll('.rcard'));
  orig.forEach(function(c){var cl=c.cloneNode(true);cl.setAttribute('aria-hidden','true');track.appendChild(cl);});
  // 'is-running' matches the CSS keyframe class in mare-home-ext.css
  track.classList.add('is-running');
})();

// Products horizontal scroll — IDs pPrev / pNext
(function(){
  var track=document.getElementById('pscrollTrack');
  var btnPrev=document.getElementById('pPrev');
  var btnNext=document.getElementById('pNext');
  if(!track||!btnPrev||!btnNext)return;
  var cardW=260;
  var step=cardW*2;
  btnPrev.addEventListener('click',function(){
    track.style.transform='translateX('+(Math.min(0,getX()+step))+'px)';
  });
  btnNext.addEventListener('click',function(){
    var maxShift=-(track.scrollWidth-track.parentElement.offsetWidth);
    track.style.transform='translateX('+(Math.max(maxShift,getX()-step))+'px)';
  });
  function getX(){
    var m=new DOMMatrix(window.getComputedStyle(track).transform);
    return m.m41||0;
  }
})();

// Mobile nav hamburger
(function(){
  var toggle=document.querySelector('.nav-toggle');
  var overlay=document.querySelector('.mobile-nav-overlay');
  var drawer=document.querySelector('.mobile-nav-drawer');
  var closeBtn=document.querySelector('.mobile-nav-close');
  if(!toggle)return;
  function open(){overlay.classList.add('open');drawer.classList.add('open');document.body.style.overflow='hidden';}
  function close(){overlay.classList.remove('open');drawer.classList.remove('open');document.body.style.overflow='';}
  toggle.addEventListener('click',open);
  if(closeBtn)closeBtn.addEventListener('click',close);
  if(overlay)overlay.addEventListener('click',close);
})();
